export const HEADER_HEIGHT = 200;
export const MAX_HEIGHT = 514;
export const CONTENT_WIDTH = '375px';
